module.exports = __webpack_public_path__ + "img/example_sign_col.2fdf798a.svg";